import { createController } from '../../viewer.app'

export default createController
